import "./style.css";

export default class Resources {
  static selector = ".resources";

  constructor(block) {
    this.block = block;

    window.onload = this.enableTransitions;

    this.filterButton = this.block.querySelector(".resources__heading__filter");
    this.filterMenu = this.block.querySelector(
      ".resources__heading__filter__menu"
    );
    this.menuIcon = this.block.querySelector(
      ".resources__heading__filter__icon"
    );

    // filters in the drop-down menu
    this.filterItems = this.block.querySelectorAll(
      ".resources__heading__filter__menu__item"
    );

    this.selectedFiltersWrapper = this.block.querySelector(
      ".resources__active-filters"
    );

    this.noFiltersApplied = this.block.querySelector(
      ".resources__active-filters p:nth-child(2)"
    );

    // currently active filters
    this.activeFilters = this.block.querySelectorAll(
      ".resources__active-filters__item"
    );

    this.activeFilters.forEach((el) =>
      el.addEventListener("click", this.removeFilter)
    );

    this.resourcesItems = this.block.querySelectorAll(".resources__list__item");
    this.resourcesArray = Array.from(this.resourcesItems);

    this.resourcesParent = this.block.querySelector(".resources__list");

    this.filterButton.addEventListener("click", this.showFiltersMenu);

    this.filterItems.forEach((item) => {
      item.addEventListener("click", this.activateSelectedFilter);
    });

    // array to store currently selected topics
    this.selectedTopics = [];
  }

  enableTransitions = () => {
    this.filterMenu.classList.remove("preload");
  };

  showFiltersMenu = (e) => {
    if (this.filterMenu.classList.contains("open")) {
      this.filterMenu.classList.remove("open");
      this.menuIcon.style.transform = "rotate(0deg)";
    } else {
      this.filterMenu.classList.add("open");
      this.menuIcon.style.transform = "rotate(180deg)";
    }
  };

  activateSelectedFilter = (e) => {
    var selectedTopic = e.currentTarget.dataset.filterValue;

    if (!this.selectedTopics.includes(selectedTopic)) {
      this.selectedTopics.push(selectedTopic);

      // make selected filter greyed-out in drop-down menu
      this.filterItems.forEach((item) => {
        if (item.dataset.filterValue == selectedTopic) {
          item.style.opacity = 0.5;
        }
      });
    }

    this.activeFilters.forEach((filter) => {
      if (selectedTopic == filter.dataset.selectedFilterValue) {
        this.noFiltersApplied.style.display = "none";
        filter.style.display = "flex";
      }
    });

    this.filterResources();
  };

  filterResources = () => {
    // filter items based on topic in data attribute
    let filteredItems = this.resourcesArray.filter((item) => {
      var itemTopics = item.dataset.topicValue.split(", ");

      if (this.selectedTopics.length == 0) {
        // reset resources if all filters are removed
        return itemTopics;
      }

      // check if any of the item topics is found in the selected topics array
      const found = this.selectedTopics.some((r) => itemTopics.includes(r));
      return found;
    });

    this.renderFilteredItems(filteredItems);
  };

  renderFilteredItems = (data) => {
    // check if parent has at least one child -> remove until no children are left
    while (this.resourcesParent.firstChild) {
      this.resourcesParent.removeChild(this.resourcesParent.firstChild);
    }
    data.forEach((el) => this.resourcesParent.appendChild(el));
  };

  removeFilter = (e) => {
    e.currentTarget.style.display = "none";
    var removedFilter = e.currentTarget.dataset.selectedFilterValue;

    // remove filter from array of filters
    var position = this.selectedTopics.indexOf(removedFilter);
    if (~position) this.selectedTopics.splice(position, 1);

    this.filterItems.forEach((item) => {
      if (item.dataset.filterValue == removedFilter) {
        item.style.opacity = 1;
      }
    });

    if (this.selectedTopics.length == 0) {
      this.noFiltersApplied.style.display = "block";
      this.renderFilteredItems(this.resourcesItems);
    }

    this.filterResources();
  };
}
